import { EntityTypes } from 'constants/entities';

export function getEntities(state, type: EntityTypes, key?, id?) {
  if (!state[type]) {
    console.warn(type + 'is wrong');
    return [];
  }

  return Object.values(state[type])
    ? key && id
      ? (Object.values(state[type]).filter((ent: any) => ent[key] === id && confirmStatus(ent)) as any[])
      : (Object.values(state[type]).filter(confirmStatus) as any[])
    : [];
}

function confirmStatus(entity) {
  if (entity.status) return entity.status > -1;

  return true;
}
